import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface AppState {
  isExtensionInstalled: boolean;
}

const initialState: AppState = {
  // Immediate check on store initialization
  isExtensionInstalled: !!(window as any).MOONSKINS_EXTENSION_ENABLED,
};

const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    setExtensionInstalled: (state, action: PayloadAction<boolean>) => {
      state.isExtensionInstalled = action.payload;
    }
  },
});

export const { setExtensionInstalled } = appSlice.actions;
export default appSlice.reducer;